/**
 * Script snippet that users run in the recipe site's Console (F12) to copy
 * cookies to the clipboard. Our RecipeAuthModal instructs users to paste the
 * result back into the app so we can send it to POST /recipes/auth/import-cookies.
 *
 * Note: document.cookie only includes non-httpOnly cookies. Sites that use
 * httpOnly session cookies require manual copy from DevTools → Application → Cookies.
 */
export function getCookieCopyScript() {
  return `(function(){
  var domain = window.location.hostname.replace(/^www\\./, '');
  var cookies = document.cookie.split(';').reduce(function(acc, cookie) {
    var parts = cookie.trim().split('=');
    if (parts[0] && parts[1]) acc[parts[0]] = decodeURIComponent(parts[1]);
    return acc;
  }, {});
  var out = JSON.stringify({ domain: domain, cookies: cookies }, null, 2);
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(out).then(function() {
      console.log('Cookies copied to clipboard. Paste them in the app and click Import.');
    }).catch(function() {
      console.log(out);
    });
  } else {
    console.log(out);
  }
})();`
}
